import { useEffect, useState } from 'react';
import { format, isSameDay, parseISO } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { useQuery } from '@apollo/client';
import { GET_EVENT_SLOTS } from '@general/graphql/event.graph';

const useEventSlots = ({ eventCode, eventDay }) => {
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    const { data } = useQuery(GET_EVENT_SLOTS, {
        variables: {
            eventCode,
        },
    });

    useEffect(() => {
        if (!data) {
            return;
        }

        const hoursForCurrentDay = data.eventSlots.find(({ startsAt }) => isSameDay(new Date(startsAt), eventDay));
        const eventDateFormatted = format(eventDay, 'yyyy-MM-dd');

        setStartTime(
            hoursForCurrentDay ? new Date(hoursForCurrentDay.startsAt) : new Date(`${eventDateFormatted} 08:00`)
        );
        setEndTime(hoursForCurrentDay ? new Date(hoursForCurrentDay.endsAt) : new Date(`${eventDateFormatted} 17:00`));
    }, [data, eventDay]);

    return { startTime, endTime };
};

export default useEventSlots;
